export default __webpack_public_path__ + "0b2117c87341573606d082b728e4be67.svg";